import { createFileRoute, Link } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { useServerFn } from "@tanstack/react-start";
import { listParashiot } from "@/lib/parashiot.functions";

export const Route = createFileRoute("/_authenticated/parashiot/")({
  component: ParashiotIndex,
});

function ParashiotIndex() {
  const fn = useServerFn(listParashiot);
  const { data, isLoading } = useQuery({ queryKey: ["parashiot"], queryFn: () => fn() });

  const byBook: Record<string, any[]> = {};
  (data ?? []).forEach((p) => {
    byBook[p.book] = byBook[p.book] ?? [];
    byBook[p.book].push(p);
  });

  return (
    <div className="space-y-8">
      <div>
        <h1 className="font-serif text-3xl font-semibold text-primary">As 54 Parashiot</h1>
        <p className="mt-1 text-muted-foreground">
          O ciclo anual completo da Torá. Clique em uma porção para ver todos os ensinos.
        </p>
      </div>

      {isLoading ? (
        <div
          className="min-h-[80vh] animate-pulse rounded-xl bg-secondary"
          role="status"
          aria-label="Carregando"
        />
      ) : (
        <div className="space-y-8">
          {Object.entries(byBook).map(([book, list]) => (
            <section key={book}>
              <h2 className="mb-4 font-serif text-xl font-semibold text-primary">{book}</h2>
              <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
                {list.map((p) => (
                  <Link
                    key={p.id}
                    to="/parashiot/$slug"
                    params={{ slug: p.slug }}
                    className="group flex items-center gap-4 rounded-xl border border-border bg-card p-4 transition-colors hover:border-primary/40 hover:bg-secondary/40"
                  >
                    <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-primary/10 font-serif text-lg font-semibold text-primary">
                      {p.number}
                    </div>
                    <div className="min-w-0 flex-1">
                      <div className="font-serif text-lg font-semibold text-foreground group-hover:text-primary">
                        {p.name_translit}
                      </div>
                      <div className="truncate text-xs text-muted-foreground">
                        {p.name_pt} · {p.teachingCount} ensino{p.teachingCount === 1 ? "" : "s"}
                      </div>
                    </div>
                    <div className="font-serif text-lg text-muted-foreground">{p.name_he}</div>
                  </Link>
                ))}
              </div>
            </section>
          ))}
        </div>
      )}
    </div>
  );
}
